<template>
	<div>
		<h4 class="mb-3">{{ $t('select-timetable') }}</h4>

		<b-spinner v-if="loadingTimetables" small class="mb-3"></b-spinner>

		<div v-else>
			<b-form-group class="mb-3">
				<b-form-radio v-model="mode" value="existing" class="mb-2" :disabled="!timetables.length">
					{{ $t('import-into-existing-timetable') }}
				</b-form-radio>
				<b-form-select
					v-if="mode === 'existing'"
					v-model="selectedId"
					:options="timetableOptions"
					class="mb-3 ml-4"
					style="max-width: 400px"
				></b-form-select>

				<b-form-radio v-model="mode" value="new">
					{{ $t('create-a-new-timetable') }}
				</b-form-radio>
				<b-form-input
					v-if="mode === 'new'"
					v-model="name"
					placeholder="Timetable name"
					class="mt-2 ml-4"
					style="max-width: 400px"
				></b-form-input>
			</b-form-group>

			<div class="d-flex">
				<b-button variant="outline-secondary" class="mr-2" @click="$emit('back')">← {{ $t('back') }}</b-button>
				<b-button
					variant="success"
					:disabled="!selectionValid || importing"
					@click="onImport"
					data-cy="import-button"
				>
					<b-spinner v-if="importing" small class="mr-1"></b-spinner>
					{{ importing ? $t('importing') : $t('import-timetable') }}
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		timetables:        { type: Array,   default: () => [] },
		loadingTimetables: { type: Boolean, default: false },
		importing:         { type: Boolean, default: false },
		initialName:       { type: String,  default: '' },
	},
	data() {
		return {
			mode:       'new',
			selectedId: null,
			name:       this.initialName,
		};
	},
	computed: {
		timetableOptions() {
			return this.timetables.map(t => ({
				value: t.tttimetable_id || t.id,
				text:  t.tttimetable_name || t.name || '(Untitled)',
			}));
		},
		selectionValid() {
			return this.mode === 'existing'
				? !!this.selectedId
				: this.name.trim().length > 0;
		},
	},
	watch: {
		timetables(val) {
			if (!val.length) this.mode = 'new';
		},
		initialName(val) {
			if (!this.name) this.name = val;
		},
	},
	methods: {
		onImport() {
			this.$emit('import', {
				mode:        this.mode,
				timetableId: this.selectedId,
				name:        this.name.trim(),
			});
		},
	},
};
</script>
